import { LOGGED_OUT_PATH } from '../../constants'
import { FRESH_LOGIN_PARAM } from '../sso'
import type { SSO_CLIENT } from '../sso'

/**
 * Where Cognito's /logout returns to after a SIGN-OUT.
 *
 * Its own variable because the endpoint is shared but the destination is not:
 * SSOLandingPage hops through the same /logout mid-SIGN-IN and has to come back
 * to a route that resumes authorizing, not to the logged-out page.
 *
 * Point this at <origin>/logged-out -- once that URL is registered in each
 * Cognito app client's allowed sign-out URLs -- and the pass through /login
 * disappears. Until then it falls back to the older variable, so behaviour is
 * unchanged and the two can be flipped per environment.
 */
export const cognitoSignOutRedirectUri = (): string | undefined =>
  process.env.REACT_APP_COGNITO_SIGNOUT_REDIRECT_URI ??
  process.env.REACT_APP_COGNITO_LOGOUT_REDIRECT_URI

/** Carries the SSO client an ended session belonged to, e.g. ?source=TELECARE_AUTH0. */
export const LOGGED_OUT_SOURCE_PARAM = 'source'

export const buildLoggedOutUrl = (
  clientName: SSO_CLIENT | undefined,
  cognitoSessionCleared: boolean
): string => {
  if (!clientName) return LOGGED_OUT_PATH
  const params = new URLSearchParams({ [LOGGED_OUT_SOURCE_PARAM]: clientName })
  if (cognitoSessionCleared) params.set(FRESH_LOGIN_PARAM, '1')
  return `${LOGGED_OUT_PATH}?${params.toString()}`
}
